import styled from 'styled-components';

import mediaQueries from 'constants/mediaQueries';
import {
  imageBoxShadow,
  imageBackgroundFallback,
  colorBrandPrimary,
  colorBrandSecondary,
  colorWhite,
} from 'constants/colors';

// If there are less than FANCY_GRID_MIN_ITEMS items render one row layout
const FANCY_GRID_MIN_ITEMS = 4;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-template-rows: auto;
  grid-gap: 24px;
  grid-auto-flow: dense;
  margin: 32px 0;

  ${mediaQueries.tabletAndMobileOnly} {
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  }
`;

export const ImageGridItem = styled.div<{ itemsLength: number }>`
  min-height: 200px;
  display: inline-block;
  position: relative;
  ${imageBoxShadow}

  ${mediaQueries.tabletAndLarger} {
    min-height: 210px;

    &:first-child {
      ${({ itemsLength }) =>
        itemsLength >= FANCY_GRID_MIN_ITEMS
          ? `
        grid-row: span 2;
        grid-column: span 2;
        `
          : ''}
    }
  }
`;

export const ImageLabel = styled.span`
  position: absolute;
  bottom: 8px;
  left: 8px;
  background-color: ${colorBrandPrimary};
  color: ${colorWhite};
  font-size: 14px;
  line-height: 1.58;
  padding: 0 6px;
  display: inline-block;
  font-weight: 300;
`;

export const ImageGridLink = styled.a<{ imageUrl?: string }>`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${imageBackgroundFallback};
  background-position: center;
  background-size: cover;
  background-image: url(${props => props.imageUrl || ''});

  &:hover {
    ${ImageLabel} {
      background-color: ${colorBrandSecondary};
    }
  }
`;
